var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGooglePlayBadge = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#google-play-badge-clip)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.35087 0.294024C1.12862 0.521174 1 0.874826 1 1.33282V17.6692C1 18.1271 1.12862 18.4808 1.35087 18.7079L1.40573 18.7578L10.7819 9.60718V9.39111L1.40573 0.24047L1.35087 0.294024Z",
  fill: "url(#google-play-badge-paint0)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.9032 12.6562L10.7812 9.6045V9.38843L13.9069 6.33668L13.9769 6.37639L17.6786 8.43274C18.735 9.01631 18.735 9.97662 17.6786 10.5639L13.9769 12.6165L13.9032 12.6562V12.6562Z",
  fill: "url(#google-play-badge-paint1)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.9704 12.6185L10.7748 9.49843L1.34375 18.7072C1.69462 19.0674 2.2668 19.1108 2.91747 18.7506L13.9704 12.6185",
  fill: "url(#google-play-badge-paint2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.9704 6.37992L2.91747 0.247796C2.2668 -0.108627 1.69462 -0.0652292 1.34375 0.294887L10.7748 9.5L13.9704 6.37992Z",
  fill: "url(#google-play-badge-paint3)"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "google-play-badge-paint0",
  x1: 9.94939,
  y1: 17.8393,
  x2: -2.44421,
  y2: 5.14538,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00A0FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0066,
  stopColor: "#00A1FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2601,
  stopColor: "#00BEFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5122,
  stopColor: "#00D2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7604,
  stopColor: "#00DFFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00E3FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "google-play-badge-paint1",
  x1: 19.0542,
  y1: 9.49543,
  x2: 0.746861,
  y2: 9.49543,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4087,
  stopColor: "#FFBD00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7754,
  stopColor: "#FFA500"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF9C00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "google-play-badge-paint2",
  x1: 12.2327,
  y1: 7.8023,
  x2: -4.574,
  y2: -9.41167,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF3A44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C31162"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "google-play-badge-paint3",
  x1: -1.03023,
  y1: 24.1438,
  x2: 6.47472,
  y2: 16.4571,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#32A071"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0685,
  stopColor: "#2DA771"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4762,
  stopColor: "#15CF74"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8009,
  stopColor: "#06E775"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00F076"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "google-play-badge-clip"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white"
})))));
export default SvgGooglePlayBadge;